import { Controller } from 'react-hook-form';
import { Select, SelectSize, SelectType } from '@ui/src';
import { useAppSelector } from '@store';
import InfoRow from '../info-row';
import { NewApplicationStatus } from '../../../hoc/new-application/types';
import { CorporateApplicationStepThreeTypes } from '../types';

import cn from '../new-application.module.css';
import StepPartBlock from './parts/step-part-block';

const NewApplicationCorporateInfoStepThree = ({
  control,
  status,
  isEditable,
  errors,
  clearErrors,
}: CorporateApplicationStepThreeTypes) => {
  const {
    monthlyTurnoverCorporate: monthlyTurnover,
    numberOfIncomingTransactionsCorporate: numberOfIncomingTransactions,
    numberOfOutgoingTransactionsCorporate: numberOfOutgoingTransactions,
    valueOfIncomingTransactionsCorporate: valueOfIncomingTransactions,
    valueOfOutgoingTransactionsCorporate: valueOfOutgoingTransactions,
    maxValueOfIncomingPaymentCorporate: maxValueOfIncomingPayment,
    maxValueOfOutgoingPaymentCorporate: maxValueOfOutgoingPayment,
    productsCorporate,
    baseCurrency,
  } = useAppSelector((state) => state.customersDictionaries);

  return (
    <div className={cn.stepBlockWrapper} style={{ zIndex: 19 }}>
      <div className={cn.stepBlockContent}>
        <StepPartBlock title="Monthly Volumes">
          <InfoRow
            title={`Monthly Turnover (${baseCurrency?.name})`}
            id="monthlyTurnoverRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyTurnoverRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyTurnoverRangeId"
                  placeholder="Select range"
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyTurnoverRangeId']);
                  }}
                  list={monthlyTurnover}
                  size={SelectSize.SMALL}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={errors?.monthlyTurnoverRangeId?.message}
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>

          <InfoRow
            title="N. of incoming transactions"
            id="monthlyNumberIncomingTransactionsRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyNumberIncomingTransactionsRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyNumberIncomingTransactionsRangeId"
                  placeholder="Select range"
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyNumberIncomingTransactionsRangeId']);
                  }}
                  list={numberOfIncomingTransactions}
                  size={SelectSize.SMALL}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={
                    errors?.monthlyNumberIncomingTransactionsRangeId?.message
                  }
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
          <InfoRow
            title="N. of outgoing transactions"
            id="monthlyNumberOutgoingTransactionsRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyNumberOutgoingTransactionsRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyNumberOutgoingTransactionsRangeId"
                  placeholder="Select range"
                  list={numberOfOutgoingTransactions}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyNumberOutgoingTransactionsRangeId']);
                  }}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={
                    errors?.monthlyNumberOutgoingTransactionsRangeId?.message
                  }
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
          <InfoRow
            title={`Value of incoming transactions (${baseCurrency?.name})`}
            id="monthlyValueIncomingTransactionsRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyValueIncomingTransactionsRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyValueIncomingTransactionsRangeId"
                  placeholder="Select range"
                  list={valueOfIncomingTransactions}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyValueIncomingTransactionsRangeId']);
                  }}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={
                    errors?.monthlyValueIncomingTransactionsRangeId?.message
                  }
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
          <InfoRow
            title={`Value of outgoing transactions (${baseCurrency?.name})`}
            id="monthlyValueOutgoingTransactionsRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyValueOutgoingTransactionsRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyValueOutgoingTransactionsRangeId"
                  placeholder="Select range"
                  list={valueOfOutgoingTransactions}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyValueOutgoingTransactionsRangeId']);
                  }}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={
                    errors?.monthlyValueOutgoingTransactionsRangeId?.message
                  }
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
          <InfoRow
            title={`Max. value of incoming payment (${baseCurrency?.name})`}
            id="monthlyMaxValueIncomingPaymentRangeId"
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyMaxValueIncomingPaymentRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyMaxValueIncomingPaymentRangeId"
                  placeholder="Select range"
                  list={maxValueOfIncomingPayment}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyMaxValueIncomingPaymentRangeId']);
                  }}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={errors?.monthlyMaxValueIncomingPaymentRangeId?.message}
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
          <InfoRow
            title={`Max. value of outgoing payment (${baseCurrency?.name})`}
            id="monthlyMaxValueOutgoingPaymentRangeId"
            className={cn.infoRowRangeBlock}
            lessPadding
          >
            <Controller
              control={control}
              name="monthlyMaxValueOutgoingPaymentRangeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="monthlyMaxValueOutgoingPaymentRangeId"
                  placeholder="Select range"
                  list={maxValueOfOutgoingPayment}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['monthlyMaxValueOutgoingPaymentRangeId']);
                  }}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={errors?.monthlyMaxValueOutgoingPaymentRangeId?.message}
                  borderless
                  fullWidth
                />
              )}
            />
          </InfoRow>
        </StepPartBlock>
        <StepPartBlock title="Products & Services">
          <Controller
            control={control}
            name="productIds"
            render={({ field: { value } }) => (
              <input type="hidden" value={value} name="products" />
            )}
          />
          <InfoRow
            title="Products"
            id="products"
            className={cn.infoRowProductsBlock}
            lessPadding
          >
            <Controller
              control={control}
              name="productIds"
              defaultValue={[]}
              render={({ field: { onChange, value } }) => (
                <Select
                  name="productIds"
                  placeholder="Select products"
                  list={productsCorporate}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors(['productIds', 'products']);
                  }}
                  mode={SelectType.MULTIPLE}
                  selectWrapperClassName={
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? cn.selectDisabled
                      : ''
                  }
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={
                    errors?.productIds?.message || errors?.products?.message
                  }
                  borderless
                />
              )}
            />
          </InfoRow>
        </StepPartBlock>
      </div>
    </div>
  );
};

export default NewApplicationCorporateInfoStepThree;
